import { Auth } from 'aws-amplify';
import gql from 'graphql-tag';
import store from '@/store';
import apolloClient from '@/plugins/apollo';

async function getUser() {
  return Auth.currentAuthenticatedUser()
    .then((data) => {
      if (data && data.signInUserSession) {
        if (!store.state.user) {
          store.commit('user', data);

          // Fetch dark_theme attribute from user
          const { sub } = data.attributes;
          const observer = apolloClient.subscribe({
            query: gql`
              subscription get_user_theme($sub: String!) {
                users_by_pk(sub: $sub) {
                  dark_theme
                  map_layer
                }
              }
            `,
            variables: {
              sub,
            },
          });
          observer.subscribe({
            next(res) {
              const dark = res.data.users_by_pk.dark_theme;
              const layer = res.data.users_by_pk.map_layer;
              store.commit('darkTheme', !!(dark));
              store.commit('mapLayer', layer);
            },
            error(err) {
              console.log(err);
            },
          });
        }
        return data;
      }
      return null;
    })
    .catch((e) => {
      console.error(e);
      store.commit('user', null);
      return null;
    });
}

export default getUser;
